const PathConstants = {
  HOME: "/",
  QrScanner: "/qr-scanner",
  Attendance: "/attendance-records",
};

export default PathConstants;
